module.exports = "/_next/static/images/img_list-1-09fdf590d631c3aedf75f882e9ac5c9c.webp";